/* eslint-disable no-underscore-dangle */
import createSagaMiddleware from 'redux-saga';
import { configureStore } from '@reduxjs/toolkit';
import rootSaga from './sagas';
import rootReducer from './slices';

const createStore = (initialState = {}) => {
  const sagaMiddleware = createSagaMiddleware();

  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => [
      sagaMiddleware,
      ...getDefaultMiddleware({ thunk: false })
    ],
    devTools: process.env.NODE_ENV !== 'production'
  });

  sagaMiddleware.run(rootSaga);

  return store;
};

export default createStore;
